module.exports = __webpack_public_path__ + "img/favicon-nganluong.c0ca344d.svg";